import { Link } from '@/i18n/routing';
import { Icon, Tooltip, VisuallyHidden } from '@mage-ui/components';
import { buttonIcon, buttonIconIcon } from '@mage-ui/styled-system/recipes';

export const HeaderSocial = ({ data, className, isOpen, ...props }) => {
  return (
    <ul className={className} {...props}>
      {data.map((item) => (
        <li key={item.meta?.key || item.a11yLabel}>
          <Tooltip label={item.fields?.title} position='left' withArrow={true}>
            <Link
              className={buttonIcon({
                color: 'primary',
                variant: 'outlined',
              })}
              href={item.fields?.url || item.slug || '#'}
              target='_blank'
            >
              <Icon
                classNames={{ root: buttonIconIcon() }}
                name={item.fields?.icon_social}
              />
              <VisuallyHidden>{item.fields?.title}</VisuallyHidden>
            </Link>
          </Tooltip>
        </li>
      ))}
    </ul>
  );
};
